/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var IdCardIcon24Solid = forwardRef('IdCardIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 4a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4H6Zm.25 5C5.56 9 5 9.56 5 10.25v3.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-3.5C11 9.56 10.44 9 9.75 9h-3.5Zm7 1.25A.75.75 0 0 1 14 9.5h4.25a.75.75 0 0 1 0 1.5H14a.75.75 0 0 1-.75-.75ZM14 12.5a.75.75 0 0 0 0 1.5h4.25a.75.75 0 0 0 0-1.5H14Z" })));
});
